import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { createTec, getAllEquipos } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import provinces from "@doncicuto/es-provinces";
import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";
import { verificarNif, verificarCorreo, verificarTelefono } from "../../../functions/validator/formValidator";

const NuevoTecnico = () => {
  const { t } = useTranslation('common');

  const [tecnico, setTecnico] = useState({});
  const [equipos, setEquipos] = useState([]);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    if (isFetchingRef.current) {
      return;
    }
    
    try {
      isFetchingRef.current = true;
      const response = await getAllEquipos();
      setEquipos(response);
    } finally {
      isFetchingRef.current = false;
    }
  }

  function handleSubmit(data) {
    const toastInfo = toast.info(t('technicians.messages.saving'));
    let correoCorrecto = verificarCorreo(data.email);
    let nifCorrecto = verificarNif(data.nif);
    let telefonoCorrecto = verificarTelefono(data.telefono);
    let errores = false;
    const camposRequeridos = ['nif', 'email', 'nombre', 'apellidos','telefono'];

    if (Object.keys(data).length === 0) {
      toast.update(toastInfo, {
        render: t('technicians.messages.emptyTechnician'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
      errores = true;
    } else {
      if (correoCorrecto === false && data.email != undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('technicians.messages.incorrectEmail'));
        errores = true;
      }
      if (nifCorrecto === false && data.nif != undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('technicians.messages.incorrectNif'));
        errores = true;
      }
      if (telefonoCorrecto === false && data.telefono != undefined) {
        toast.dismiss(toastInfo);
        toast.error(t('technicians.messages.incorrectPhone'));
        errores = true;
      }

      const requiredFields = [ 'nif', 'email', 'apellidos','nombre'];

      requiredFields.forEach((field) => {
          if (!data[field]) {
              toast.error(t('technicians.messages.fieldRequired', { field }));
              errores = true;
          }
      });


    }

    if (!errores) {
      createTec(data)
        .then((res) => {
          const mensaje = res.data[0]
          if (mensaje.status === 200) {
            toast.update(toastInfo, {
              render: mensaje.msg,
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
           window.location.replace("/tecnicos");
          }
          else if(mensaje.status === 400){
            toast.update(toastInfo, {
              render: mensaje.msg,
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
          else if (res.status === 403) {
            if (res.message === '"email" is required') {
              toast.update(toastInfo, {
                render: t('technicians.messages.emailRequired'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            } else if (res.message === '"nif" is required') {
              toast.update(toastInfo, {
                render: t('technicians.messages.nifRequired'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            } else {
              toast.update(toastInfo, {
                render: t('messages.error'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            }
          } else {
            toast.update(toastInfo, {
              render: t('technicians.messages.unknownError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
          toast.error(t('technicians.messages.createError'));
        });
    }
  }
  
  function handleChange(evt) {
    const value = evt.target.value;
    setTecnico({
      ...tecnico,
      [evt.target.name]: value,
    });
  }

  return (
    <>
      <BreadCrumb rutas={[{ path: '/tecnicos', label: t('technicians.title') }, { path: '/tecnicos', label: t('technicians.new') }]} style={{ margin: '0 10px' }} />
      <div className="pageContent">
        <div className="gridHead">
          {t('technicians.createNew')}
        </div>
        <form className="nuevoAAFFForm">
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20, padding: '0 20px' }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.nif')}
                name="nif"
                value={tecnico.nif}
                onChange={handleChange}
                pattern="(^[0-9]{8}[A-Z]{1})$|^([A-Z]{1}[0-9]{8})$|^([A-Z]{1}[0-9]{7}[A-Z]{1}$)"
                title={t('form.nif')}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="email"
                required
                placeholder={t('form.email')}
                name="email"
                value={tecnico.email}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.firstName')}
                name="nombre"
                value={tecnico.nombre}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.lastName')}
                name="apellidos"
                value={tecnico.apellidos}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <input
                type="tel"
                required
                placeholder={t('form.phone')}
                name="telefono"
                value={tecnico.telefono}
                onChange={handleChange}
              ></input>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                required
                name="equipo"
                onChange={handleChange}
              >
                <option value={tecnico.equipo}>{t('technicians.columns.team')}</option>
                {equipos.map((e, i) => {
                  return (
                    <option key={i} value={e.id}>
                      {e.nombre}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                required
                name="provincia"
                onChange={handleChange}
              >
                <option value={tecnico.provincia}>{t('form.province')}</option>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <option key={i} value={e.name}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <select
                required
                name="rol"
                onChange={handleChange}
              >
                <option value={"TECH"}>{t('technicians.roles.technician')}</option>
                <option value={"TECH_COOR"}>{t('technicians.roles.coordinator')}</option>

              </select>
            </Grid>
          </Grid>
          <Grid style={{ display: 'flex', justifyContent: 'end', padding: 20 }}>
            <input
              type="button"
              value={t('actions.save')}
              onClick={() => handleSubmit(tecnico)}
            ></input>
          </Grid>
        </form>
      </div>
    </>
  );
};

export default NuevoTecnico;